import { render, staticRenderFns } from "./chart-pietwo.vue?vue&type=template&id=421d084e&scoped=true"
import script from "./chart-pietwo.vue?vue&type=script&lang=js"
export * from "./chart-pietwo.vue?vue&type=script&lang=js"
import style0 from "./chart-pietwo.vue?vue&type=style&index=0&id=421d084e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421d084e",
  null
  
)

export default component.exports